import React, { useEffect, useState } from "react";
import "./style.scss";
import TitleExpand from "../../Expandtitle";
import Location from "../../Location";
import Storelist from "../../../Store/Actions";
import Datedetails from "../../Datedetails";
import { DateSeparter } from "../../../Utils/helper";
import SuperstarItem from "../../SuperstarItem";
import Api from "../../../Utils/Api";

const Slotaccept = () => {
  const { ServiceDetailsStore, CreateRequestDetailsStore } = Storelist();
  const { SlotDetailUpdate } = Api();
  const [isChangeSlot, setisChangeSlot] = useState(false);
  const [SelectedSuperStar, setSelectedSuperStar] = useState(null)
  const Details = ServiceDetailsStore?.data?.bikeRequest;
  const SuperStarHandler = (id) => {
    setSelectedSuperStar(id)
  };
  const AcceptSlot = () => {
    SlotDetailUpdate({
      status: "Accepted", //Accepted, SlotChangeRequested, SlotChangeAccepted
      changedSlot: null,
      reason:null
    });
  };
  const SlotChangeSubmit = (event)=>{
    event.preventDefault();
    const data = new FormData(event.target)
    CancelSlotChange()
    SlotDetailUpdate({
      status: "SlotChangeRequested", //Accepted, SlotChangeRequested, SlotChangeAccepted
      changedSlot: data.get('slot-time'),
      reason:data.get('reason')
    });
  }
  const CancelSlotChange = ()=>{
    setisChangeSlot(false)
  }
  const AssignSuperStarHandler = ()=>{

  }
  useEffect(() => {
    return () => {
      setisChangeSlot(false);
      setSelectedSuperStar(null)
    }
  }, [])
  
  return (
    <div className="slot-accept-container">
      <TitleExpand title={"REQUIRED SERVICE"} color={"--light"} />
      <Location tag={Details?.serviceRequired?.label}>
        <span>{Details?.offer?.label}</span>
      </Location>
      <Datedetails
        date={DateSeparter(Details?.slotBooked)?.month}
        day={DateSeparter(Details?.slotBooked)?.day}
        time={DateSeparter(Details?.slotBooked)?.time?.split(" ")[0]}
        hrs={DateSeparter(Details?.slotBooked)?.time?.split(" ")[1]}
      />
      {Details?.serviceStatus==='New'&&!isChangeSlot&&<div className="slot-btn-container">
        <button className="change" onClick={setisChangeSlot}>Change slot</button>
        <button className="accept" onClick={AcceptSlot}>
          Accept
        </button>
      </div>}


        {/* CHANGE SLOT */}
        {isChangeSlot&&<form onSubmit={SlotChangeSubmit} className="change-slot-container">
          <TitleExpand title={"Slot change to"} color={"--light"} />
          <input type="datetime-local" name="slot-time" id="slot-time" required/>
          <TitleExpand title={"Reason for change"} color={"--light"} />

          <textarea name="reason" id="reason" placeholder="reason for change" required></textarea>
        <div className="slot-btn-container">
        <button className="change" type="reset"  onClick={CancelSlotChange}>Cancel</button>
        <button className="accept" type="submit" >
          Update
        </button>
      </div>
        </form>}


      {/* {JSON.stringify(CreateRequestDetailsStore)} */}
    {Details?.serviceStatus==='Accepted'&& <div>
     <div className="superstar-header">
        {/* <TitleExpand title={"NEXT"} color={"--light"} /> */}
        <p>Assign</p>
        <p>Our service superstars</p>
      </div>

      <div className="assign-superstar-container">
        {CreateRequestDetailsStore?.superStarsList?.map((item, index) => {
          if (item?.isAvailable)
            return (
              <SuperstarItem
                key={item?._id+Details?._id}
                item={item}
                color={"--light"}
                bg={'--customcolor_4'}
                isActive={item?._id===SelectedSuperStar?true:false}
                callBackHandler={SuperStarHandler}
              />
            );
        })}
      </div>
      <button className="update-btn" onClick={AssignSuperStarHandler}>Update</button>
     </div>}
    </div>
  );
};

export default Slotaccept;
